import { ReactComponent as RiBadmintonCourt } from '@/assets/icons/ri-badminton-court.svg';
import { DAYS } from '@/components/common/CalendarWeekly/constant';
import { ReactComponent as AlertIcon } from '@/assets/icons/ri-alert-line.svg';
import { currencyFormat } from '@/utils';

const formatBookingHours = (hours: number[]): {[key: number]: {start: number, end: number, duration: number}} => {
  const bookedHours = {}
  hours.sort((a, b) => a-b)
  let start = 0
  let end = 0
  let duration = 0
  hours.forEach((hour) => {
    if (hour === end) {
      end+=1
      duration+=1
      bookedHours[start].end = end
      bookedHours[start].duration = duration
    } else {
      start = hour
      end = hour+1
      duration=1
      bookedHours[start] = {
        start,
        end,
        duration
      }
    }
  })
  return bookedHours
}

const summaryData = (schedules) => {
  const summary = {}
  const hours = {}
  schedules.forEach(schedule => {
    const court = schedule.court.id
    if (hours[court]) { hours[court].push(schedule.hour) }
    else { hours[court] = [schedule.hour] }
    summary[court] = {
      fieldName: schedule.court.code,
      hours: hours[court],
      id: schedule.court.id,
      day: schedule.selectedDay,
      venuePriceId: schedule.court.venue_price_id
    }
  })
  return summary
}

const calculateLocalTax = (price: number, taxFee: number) => (price * taxFee) / 100 

const Summary = ({ selectedSchedules, selectedVenue, startDate, selectedCustomer }) => {
  let price = 0
  let venueCount = 0  
  let conflictedPrice = 0

  Object.keys(selectedSchedules).forEach((day) => {
    selectedSchedules[day].forEach(sched => {
      price += sched.totalPrice
      conflictedPrice += sched.conflictedPrice
    });
  })

  const localTax = calculateLocalTax(price - conflictedPrice, selectedVenue?.tax_fee)
  return (
  <div className='flex flex-col basis-3/12 bg-white p-0'>
    <div className='flex items-start px-8 pt-8 pb-0 gap-3 rounded-t'>
      <p className='font-bold text-lg'>New Subscription Summary</p>
    </div>
    <div className='flex flex-col items-start p-7 gap-6 rounded-b'>
      {selectedVenue && <div className='flex flex-col w-full'>
        <div className='flex justify-between items-center py-2'>
          <p className='text-sm'>Venue</p>
          <p className='font-medium text-sm'>{selectedVenue.name}</p>
        </div>
      </div>}
      {selectedCustomer.watch('customerName') && <div className='flex flex-col w-full'>
        <div className='flex justify-between items-start py-2'>
          <p className='text-sm'>Customer</p>
          <div className='flex flex-col'>
            <p className='font-medium text-sm text-right'>{selectedCustomer.getValues('customerName')?.label}</p>
            <p className='font-medium text-sm text-grey-dark text-right'>{selectedCustomer.getValues('customerName')?.clubName}</p>
          </div>
        </div>
      </div>}
      {startDate && <div className='flex flex-col w-full'>
				<div className='flex justify-between items-start py-2'>
					<p className='text-sm'>Start Date</p>
					<div className='flex flex-col items-end'>
						<p className='font-medium text-sm text-right'>{new Date(startDate).toLocaleString('en-US')}</p>
            {new Date(startDate).getDate() !== 1 && <div className='flex items-center gap-2 text-right'>
              <p className='text-red-primary'><AlertIcon /></p>
              <p className='text-jxs'>Not at the beginning of the month</p>
            </div>}
					</div>
				</div>
			</div>}
      {Object.keys(selectedSchedules).map(day => {
          const summary = summaryData(selectedSchedules[day]);
          return (!!Object.keys(summary).length &&
            <div className='flex flex-col w-full gap-4'>
              <div className='flex py-3 gap-2 bg-grey-subtle border-b border-grey-line-subtle'>
                <p className='pl-2 font-medium text-xs'>{`${DAYS[day].label}`}</p>
              </div>
              {Object.keys(summary).map(courtId => {
                venueCount += 1
                const field = summary[courtId];
                return (
                  <div className='flex px-2 py-0'>
                    <div className='flex justify-between items-center p-0 gap-28'>
                      <div className='flex p-0 gap-4'>
                        <div
                          className='flex flex-col justify-center items-center px-3 py-4 gap-2 bg-green-success rounded text-white'>
                          <RiBadmintonCourt />
                        </div>
                        <div className='flex flex-col justify-center p-0'>
                          <p className='font-medium text-sm'>{`${field.fieldName}`}</p>
                          {Object.keys(formatBookingHours(field.hours)).map(hour => {
                            const { start, end } = formatBookingHours(field.hours)[hour];
                            return (
                              <p className='text-xs text-grey-dark'>({`${start}.00 - ${end}.00`} WIB)</p>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          );
        },
      )}
      <div className='flex flex-col justify-between items-center gap-1 p-2 rounded-md border border-grey-line-subtle  w-full'>
        <p className='font-bold text-sm w-full'>Estimation</p>
        <div className='flex w-full justify-between items-center py-2'>
          <p className='text-xs'>Fields Booking ({venueCount})</p>
          <p className='font-medium text-xs'>{currencyFormat(price)}</p>
        </div>

        {conflictedPrice > 0 && <div className='flex w-full justify-between items-center py-2 text-red-primary'>
            <p className='text-xs'>Conflicted Booking</p>
            <p className='font-medium text-xs'>- {currencyFormat(conflictedPrice)}</p>
          </div>
        }
        <div className='flex w-full justify-between items-center py-2 bg-indigo-500'>
          <p className='text-xs'>Local Tax {selectedVenue?.tax_fee}%</p>
          <p className='font-medium text-xs'>{currencyFormat(localTax)}</p>
        </div>
        <div className='w-full border-b border-grey-line-subtle' />
        <div className='flex w-full justify-between items-center py-2'>
          <p className='text-xs'>Total</p>
          <p className='font-medium text-xs'>{currencyFormat(price - conflictedPrice + localTax)}</p>
        </div>
      </div>
    </div>
  </div>
  )
}
export default Summary
